<script>
	export default {
		globalData: {
			// url: 'http://192.168.3.4:9301/crest',
			// url: 'http://192.168.12.53.21:9301/crest',
			url: 'https://hsg.dctpay.com/crest',
			imgUrl: 'https://hsg.dctpay.com/filesystem/',
			brestUrl : 'https://hsg.dctpay.com/brest',
			// url: 'https://hsgcs.dctpay.com/crest',
			// brestUrl : 'https://hsgcs.dctpay.com/brest',
			// imgUrl: 'https://hsgcs.dctpay.com/filesystem/',
			
			userInfo: "",
			brestUserInfo : '',
			openId: '',
			code: '',
			token: '',
			brestToken:'',
			cityId: '',
			longitude : '',
			latitude : ''
		},
		onLaunch: function() {
		},
		onShow: function() {
		},
		onHide: function() {
		}
	}
</script>

<style lang="scss">
	/*每个页面公共css */
	@import "/static/iconfont/font.scss";
</style>
